import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetConverts } from '../../../../store/convert.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import qs from 'qs';

import { useSnackbar } from 'notistack';
import { Table, TableColumnsType } from 'antd';


import Loader from '../../../../components/Loader';
import Header from '../../../../components/layout/Header';
import Footer from '../../../../components/layout/Footer';
import Button from '../../../../components/Button';
import { warningVariant, errorVariant } from '../../../../lib/barVariant';
import useAuth from '../../../../hooks/useAuth';
import SimpleHeader from '../../../../components/layout/SimpleHeader';

interface IMatch {
  id: string;
}

const ProgramConvertTable: FC<RouteComponentProps> = ({ history, location }) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { converts, isLoading } = useSelector((state: RootState) => state.convert);
  const [name, setName] = useState('');

  useEffect(() => {
    // query to state
    if (query.name) setName(String(query.name));
  }, [location]);

  useEffect(() => {
    getConverts();
  }, []);

  const getConverts = async () => {
    const res = await dispatch(doGetConverts(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const columns: TableColumnsType<any> = [
    {
      title: 'Input',
      dataIndex: 'evaluationInput',
      key: 'evaluationInput',
      align: 'center',
      sorter: (a, b) => a.evaluationInput?.localeCompare(b.evaluationInput),
    },
    {
      title: 'Output',
      dataIndex: 'conversionScore',
      key: 'conversionScore',
      align: 'center',
      sorter: (a, b) => a.conversionScore - b.conversionScore,
    },
    {
      title: '',
      key: 'conversionCode',
      dataIndex: 'conversionCode',
      align: 'center',
      render: (value: string) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className='btn-basic pink-line small'
            onClick={() => {
              history.push(`/program/convert/${id}/table/${value}/edit?name=${name}`);
            }}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      )
    },
  ];

  return (
    <>
    <div className="content scrollbar">
    {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={`${t('program.convert.title1')} - ${name}`}
        onlyTitle
      />
      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result" />
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push(`/program/convert/${id}/table/create?name=${name}`)}
              text={t('program.award.button2')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className="comm-table__area">
          <Table
            columns={columns}
            dataSource={converts || undefined}
            pagination={{
              pageSize: 99999,
            }}
          />
        </div>
        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() => history.push('/program/convert')}
              text={t('program.convert.button1')}
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push(`/program/convert/${id}/table/create?name=${name}`)}
              text={t('program.award.button2')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3 comm-btn__area left">
            
          </div>
          <div className="col-6" />
          <div className="col-3 comm-btn__area right">
            
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default ProgramConvertTable;
